export const MULTIPLY_OPTIONS = 'multipleOptions';

export const SIZES = 'sizeIds';
export const GROUP_BY_COUNTRY = 'groupByCountry';

export const COUNTRIES = 'countries';
export const SYSTEM = 'system';
export const PLACEMENTS = 'placements';
